import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9f293e02"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "d-flex justify-center align-center",
  style: {"height":"150px"}
}
const _hoisted_2 = { class: "text-body-2 text-medium-emphasis mb-3" }
const _hoisted_3 = { class: "text-body-2 text-medium-emphasis mb-0" }
const _hoisted_4 = {
  key: 2,
  class: "text-center mt-2"
}

import { computed, onMounted, ref, watch } from "vue";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useToast } from "@/composables/useToast";
import {
  InscripcionUsuarioEquipoDTO,
  InscripcionUsuarioIndividualDTO,
} from "@/interfaces/Inscripcion";
import {
  cancelarInscripcion,
  eliminarEquipoAsync,
  getInscripcionesEquipoByUser,
  getInscripcionesIndividualByUser,
} from "@/services/InscripcionesService";
import {
  haTerminado,
  MiInscripcion,
  ordenProximos,
  ordenTerminados,
} from "@/utils/misEventos";
import LoadingGandalf from "@/components/Commons/LoadingGandalf.vue";
import TarjetaInscripcion from "@/components/Inscripcion/TarjetaInscripcion.vue";
import ModalInscripcion from "@/components/Inscripcion/ModalInscripcion.vue";
import ModalInscripcionEquipo from "@/components/Inscripcion/ModalInscripcionEquipo.vue";

const TANDA = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'MisTorneosView',
  setup(__props) {

const router = useRouter();
const { getidUsuario } = useAuth();
const { triggerToast } = useToast();
const idUsuario = Number(getidUsuario.value);

const isLoading = ref(true);
const inscripciones = ref<MiInscripcion[]>([]);
const vista = ref<"proximos" | "terminados">("proximos");
const cuantosVer = ref(TANDA);

const proximos = computed(() =>
  inscripciones.value.filter(i => !haTerminado(i)).sort(ordenProximos)
);
const terminados = computed(() =>
  inscripciones.value.filter(i => haTerminado(i)).sort(ordenTerminados)
);
const lista = computed(() => (vista.value === "proximos" ? proximos.value : terminados.value));
const visibles = computed(() => lista.value.slice(0, cuantosVer.value));
watch(vista, () => {
  cuantosVer.value = TANDA;
});

// Las individuales y las de equipo, con la misma forma para pintarlas igual
const desdeIndividual = (i: InscripcionUsuarioIndividualDTO): MiInscripcion => ({
  clave: `i${i.idInscripcion}`,
  idInscripcion: i.idInscripcion,
  idTorneo: i.idTorneo,
  idOrganizador: i.idOrganizador,
  porEquipos: false,
  torneo: i.torneo,
  estadoLista: i.estadoLista,
  esPago: i.esPago,
  ejercitoElegido: i.ejercitoElegido,
});
const desdeEquipo = (i: InscripcionUsuarioEquipoDTO): MiInscripcion => ({
  clave: `e${i.idInscripcion}`,
  idInscripcion: i.idInscripcion,
  idTorneo: i.idTorneo,
  idOrganizador: null,
  porEquipos: true,
  torneo: i.torneo,
});

const cargarInscripciones = async () => {
  try {
    const [individuales, equipos] = await Promise.all([
      getInscripcionesIndividualByUser(String(idUsuario)),
      getInscripcionesEquipoByUser(idUsuario),
    ]);
    inscripciones.value = [
      ...(individuales.data as InscripcionUsuarioIndividualDTO[]).map(desdeIndividual),
      ...(equipos.data as InscripcionUsuarioEquipoDTO[]).map(desdeEquipo),
    ].filter(i => i.torneo);
  } catch (error) {
    console.error(error);
    router.push({ name: "error" });
  }
};

const abierta = ref<MiInscripcion | null>(null);
const abrirInscripcion = (inscripcion: MiInscripcion) => {
  abierta.value = inscripcion;
};

const baja = ref<{ inscripcion: MiInscripcion; idEquipo?: number } | null>(null);
const dandoDeBaja = ref(false);
const pedirBaja = (inscripcion: MiInscripcion | null, idEquipo?: number) => {
  abierta.value = null;
  if (inscripcion) baja.value = { inscripcion, idEquipo };
};
const confirmarBaja = async () => {
  if (!baja.value) return;
  dandoDeBaja.value = true;
  try {
    if (baja.value.idEquipo) await eliminarEquipoAsync(baja.value.idEquipo);
    else await cancelarInscripcion(baja.value.inscripcion.idInscripcion);
    triggerToast("success", "Te has dado de baja");
    baja.value = null;
    await cargarInscripciones();
  } catch (error) {
    console.error(error);
    triggerToast("error", "No se ha podido dar de baja");
  } finally {
    dandoDeBaja.value = false;
  }
};

onMounted(async () => {
  if (idUsuario) await cargarInscripciones();
  isLoading.value = false;
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_chip_group = _resolveComponent("v-chip-group")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (isLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(LoadingGandalf)
        ]))
      : (_openBlock(), _createBlock(_component_v_container, {
          key: 1,
          class: "mis-eventos text-left"
        }, {
          default: _withCtx(() => [
            _createElementVNode("p", _hoisted_2, [
              _createTextVNode(" Tus partidas y resultados, en "),
              _createVNode(_component_router_link, {
                to: `/detalle-jugador/${_unref(idUsuario)}`
              }, {
                default: _withCtx(() => [
                  _createTextVNode("tu ficha de jugador")
                ]),
                _: 1
              }, 8, ["to"]),
              _createTextVNode(". ")
            ]),
            _createVNode(_component_v_chip_group, {
              modelValue: vista.value,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((vista).value = $event)),
              mandatory: "",
              column: "",
              "selected-class": "text-primary",
              class: "mb-2"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_chip, {
                  value: "proximos",
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Próximos y en curso (" + _toDisplayString(proximos.value.length) + ")", 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_chip, {
                  value: "terminados",
                  filter: ""
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Terminados (" + _toDisplayString(terminados.value.length) + ")", 1)
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["modelValue"]),
            (lista.value.length === 0)
              ? (_openBlock(), _createBlock(_component_v_card, {
                  key: 0,
                  variant: "outlined",
                  class: "pa-4 text-center"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("p", _hoisted_3, _toDisplayString(vista.value === "proximos"
            ? "No estás inscrito en ningún evento próximo."
            : "Aún no has terminado ningún evento."), 1)
                  ]),
                  _: 1
                }))
              : (_openBlock(), _createBlock(_component_v_row, {
                  key: 1,
                  dense: ""
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(visibles.value, (inscripcion) => {
                      return (_openBlock(), _createBlock(_component_v_col, {
                        key: inscripcion.clave,
                        cols: "12",
                        sm: "6",
                        lg: "4"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(TarjetaInscripcion, {
                            inscripcion: inscripcion,
                            onVerInscripcion: abrirInscripcion
                          }, null, 8, ["inscripcion"])
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  ]),
                  _: 1
                })),
            (lista.value.length > visibles.value.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createVNode(_component_v_btn, {
                    variant: "tonal",
                    size: "small",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (cuantosVer.value += TANDA))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(" Ver más (" + _toDisplayString(lista.value.length - visibles.value.length) + ") ", 1)
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true)
          ]),
          _: 1
        })),
    (abierta.value && !abierta.value.porEquipos)
      ? (_openBlock(), _createBlock(ModalInscripcion, {
          key: abierta.value.clave,
          idInscripcion: abierta.value.idInscripcion,
          idUsuario: _unref(idUsuario),
          idTorneo: abierta.value.idTorneo,
          idOrganizador: abierta.value.idOrganizador ?? 0,
          ejercitoElegido: abierta.value.ejercitoElegido ?? null,
          onEliminarInscripcion: _cache[2] || (_cache[2] = ($event: any) => (pedirBaja(abierta.value))),
          onActualizada: cargarInscripciones,
          onClose: _cache[3] || (_cache[3] = ($event: any) => (abierta.value = null))
        }, null, 8, ["idInscripcion", "idUsuario", "idTorneo", "idOrganizador", "ejercitoElegido"]))
      : _createCommentVNode("", true),
    (abierta.value?.porEquipos)
      ? (_openBlock(), _createBlock(ModalInscripcionEquipo, {
          key: abierta.value.clave,
          idInscripcion: abierta.value.idInscripcion,
          idUsuario: _unref(idUsuario),
          idTorneo: abierta.value.idTorneo,
          idOrganizador: abierta.value.idOrganizador,
          onEliminarInscripcionEquipo: _cache[4] || (_cache[4] = idEquipo => pedirBaja(abierta.value, idEquipo)),
          onActualizada: cargarInscripciones,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (abierta.value = null))
        }, null, 8, ["idInscripcion", "idUsuario", "idTorneo", "idOrganizador"]))
      : _createCommentVNode("", true),
    _createVNode(_component_v_dialog, {
      "model-value": !!baja.value,
      "max-width": "420",
      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (baja.value = null))
    }, {
      default: _withCtx(() => [
        (baja.value)
          ? (_openBlock(), _createBlock(_component_v_card, { key: 0 }, {
              default: _withCtx(() => [
                _createVNode(_component_v_card_title, { class: "text-wrap" }, {
                  default: _withCtx(() => [
                    _createTextVNode("¿Darte de baja?")
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_text, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(baja.value.idEquipo
            ? `Se dará de baja a tu equipo de ${baja.value.inscripcion.torneo.nombreTorneo}.`
            : `Dejarás de estar inscrito en ${baja.value.inscripcion.torneo.nombreTorneo}.`), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_spacer),
                    _createVNode(_component_v_btn, {
                      variant: "text",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (baja.value = null))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode("Volver")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      variant: "flat",
                      loading: dandoDeBaja.value,
                      onClick: confirmarBaja
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Darme de baja ")
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["model-value"])
  ], 64))
}
}

})